import { GETTER_STREAM_CTRL, MUTATION_STREAM_CTRL } from '@/store/const/type'

const state = {
  isVisible: false,
  id: '',
  name: '',
  key: '',
  owner: ''
}

const actions = {}

const mutations = {
  [MUTATION_STREAM_CTRL.OPEN]: (state, { id, name, key, owner }) => {
    state.isVisible = true
    state.id = id
    state.name = name
    state.key = key
    state.owner = owner
  },
  [MUTATION_STREAM_CTRL.CLOSE]: (state) => {
    state.isVisible = false
    state.id = ''
    state.name = ''
    state.key = ''
    state.owner = ''
  }
}

const getters = {
  [GETTER_STREAM_CTRL.IS_VISIBLE]: (state) => state.isVisible,
  [GETTER_STREAM_CTRL.INFO]: ({ id, name, key, owner }) => ({ id, name, key, owner })
}

export const streamCtrl = { state, actions, mutations, getters }
